var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('timesheet-page',{attrs:{"pageType":_vm.pageType}})}
var staticRenderFns = []

export { render, staticRenderFns }